import React, { Component } from "react";

class ProfileBanner extends Component {
  render() {
    return (
      <div className="profile-banner">
        <div className="inner">
          <div className="banner-subtitle">{this.props.title}</div>
          <div className="card-block" style={{ minHeight: "204px" }}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default ProfileBanner;
